export const ACTION_RESET = 'FETCH_HKMBDATALISTBYIDS_RESET';
export const ACTION_REQUEST = 'FETCH_HKMBDATALISTBYIDS_REQUEST';
export const ACTION_SUCCESS = 'FETCH_HKMBDATALISTBYIDS_SUCCESS';
export const ACTION_ERROR = 'FETCH_HKMBDATALISTBYIDS_ERROR';
